<template>
    <div>
        <!--
        <q-input :label="label" ref="input" v-model="tel" :model-value="val" type="tel" :outlined="outlined" />
        -->
        <q-input :label="label" ref="input" v-model="tel" :model-value="val" type="tel" borderless style="background-color: white; border-radius: 16px; padding: 0 10px 0 10px; border: 2px solid #B2D0EB" input-style="color: black">
            <template v-slot:prepend>
                <q-icon :name="icon" v-if="icon" style="color: #323758" />
            </template>
        </q-input>
    </div>
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';

export default {
    name: 'PhoneInput',
    mixins: [uiControlMixin],
    props: {
        modelValue: {
            type: String,
            default: undefined,
        },
        label: {
            type: String,
            default: 'Мобильный телефон',
        },
        icon: {
            type: String,
            default: 'call',
        },
    },
    mounted () {
        this.val = this.value;
    },
    data () {
        return {
            tel: undefined,
            val: undefined,
        };
    },
    watch: {
        tel (v) {
            this.val = v;
            this.$emit('update:modelValue', this.puryfyTel(v));
        },
        modelValue (v) {
            if (!this.val) {
                this.val = this.formatTel(v);
            }
        },
    },
    methods: {
        select () {
            this.$refs.input.select();
        },
        puryfyTel (tel) {
            let result = tel.replaceAll('+', '');
            result = result.replaceAll('(', '');
            result = result.replaceAll(')', '');
            result = result.replaceAll('-', '');
            result = result.replaceAll(' ', '');
            const tels = result.match(/^\d+$/);
            if (!tels) {
                return '';
            }
            if (tels.length > 0) {
                // eslint-disable-next-line prefer-destructuring
                result = tels[0];
            }
            if (result.length > 0 && result[0] === '8' && tel[0] !== '+') {
                result = `7${result.slice(1)}`;
            }
            return result;
        },
        formatTel (tel) {
            if (!tel) {
                return tel;
            }
            if (tel.length === 0) {
                return tel;
            }
            if (tel[0] === '7' && tel.length === 11) {
                tel = `+7 (${tel.slice(1, 4)}) ${tel.slice(4, 7)}-${tel.slice(7, 9)}-${tel.slice(9, 11)}`;
            }
            return tel;
        },
    },
};
</script>

<style scoped>

</style>
